(function () {
    'use strict';

    angular.module("imApp").factory("accountingBsService", ['$ihttp', function ($ihttp) {
        var service = {
            getAccountingBs: function (parms) {
                return $ihttp.post({
                    method: 2817,
                    parameters: parms || {}
                });
            },
            listAccountingYears: function (parms) {
                return $ihttp.post({
                    method: 2820,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();